/* PainGone v4 interactions — modals, carousels, swipe rows, menu drawer, search.
   Re-initialises when the Theme Editor reloads a section. */
(function () {
  'use strict';
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var $ = function (s, c) { return (c || document).querySelector(s); };
  function once(el, k) { var f = 'pg4' + k; if (el.dataset[f]) return false; el.dataset[f] = '1'; return true; }

  /* ---- modals ---- */
  function openModal(id) { var m = document.getElementById(id); if (!m) return; m.classList.add('pg4-open'); document.body.style.overflow = 'hidden'; var v = $('video', m); if (v) { var p = v.play(); if (p && p.catch) p.catch(function(){}); } }
  function closeModal(m) { if (!m) return; m.classList.remove('pg4-open'); document.body.style.overflow = ''; var f = $('iframe', m); if (f) { var s = f.src; f.src = ''; f.src = s; } var v = $('video', m); if (v) v.pause(); }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-pg4-open]'); if (o) { e.preventDefault(); openModal(o.getAttribute('data-pg4-open')); }
    var c = e.target.closest('[data-pg4-close]'); if (c) closeModal(document.getElementById(c.getAttribute('data-pg4-close')));
    if (e.target.classList && e.target.classList.contains('pg4-modal')) closeModal(e.target);
    if (e.target.classList && e.target.classList.contains('pg4-drawer')) closeDrawer();
    if (!e.target.closest('[data-pg4-dropdown]')) $$('[data-pg4-dropdown].pg4-open').forEach(function (x) { x.classList.remove('pg4-open'); });
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { $$('.pg4-modal.pg4-open').forEach(closeModal); closeDrawer(); } });

  /* ---- drawer ---- */
  function closeDrawer() { var d = $('[data-pg4-drawer]'); if (!d || d.hidden) return; d.hidden = true; document.body.style.overflow = ''; $$('[data-pg4-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); }); }
  function initHeader(root) {
    $$('[data-pg4-drawer-open]', root).forEach(function (b) { if (!once(b, 'Dr')) return; b.addEventListener('click', function () { var d = $('[data-pg4-drawer]'); if (!d) return; d.hidden = false; document.body.style.overflow = 'hidden'; b.setAttribute('aria-expanded', 'true'); var c = $('[data-pg4-drawer-close]', d); if (c) c.focus(); }); });
    $$('[data-pg4-drawer-close]', root).forEach(function (b) { if (!once(b, 'Dc')) return; b.addEventListener('click', closeDrawer); });
    $$('[data-pg4-search-toggle]', root).forEach(function (b) { if (!once(b, 'St')) return; b.addEventListener('click', function () { var f = document.getElementById(b.getAttribute('aria-controls')); if (!f) return; f.hidden = !f.hidden; $$('[data-pg4-search-toggle]').forEach(function (x) { x.setAttribute('aria-expanded', f.hidden ? 'false' : 'true'); }); if (!f.hidden) { var i = $('input[type=search]', f); if (i) i.focus(); } }); });
    $$('[data-pg4-dropdown]', root).forEach(function (d) { if (!once(d, 'Dd')) return; var t = d.firstElementChild;
      var setOpen = function (on) { d.classList.toggle('pg4-open', on); t.setAttribute('aria-expanded', on ? 'true' : 'false'); };
      t.addEventListener('click', function (e) { e.preventDefault(); var on = !d.classList.contains('pg4-open'); $$('[data-pg4-dropdown].pg4-open').forEach(function (x) { if (x !== d) { x.classList.remove('pg4-open'); x.firstElementChild.setAttribute('aria-expanded','false'); } }); setOpen(on); });
      d.addEventListener('mouseleave', function () { setOpen(false); });
    });
  }

  /* ---- comp carousels (gallery with dots/thumbs) ---- */
  function initCarousels(root) {
    $$('[data-pg4-carousel]', root).forEach(function (c) {
      if (!once(c, 'Ca')) return;
      var t = $('.pg4-carousel-track, .pg4-top-carousel-track', c), slides = $$('.pg4-carousel-slide, .pg4-top-carousel-slide', c), dots = $$('.pg4-dot, .pg4-top-dot', c), thumbs = $$('.pg4-thumb, .pg4-top-thumb', c), i = 0, x0 = null, dx = 0;
      if (!t || !slides.length) return;
      var go = function (n) { i = (n + slides.length) % slides.length; t.style.transform = 'translateX(-' + (i * 100) + '%)'; dots.forEach(function (d, k) { d.classList.toggle('pg4-active', k === i); }); thumbs.forEach(function (d, k) { d.classList.toggle('pg4-active', k === i); }); slides.forEach(function (s, k) { $$('video', s).forEach(function (v) { if (k !== i) v.pause(); }); }); };
      $$('[data-pg4-prev]', c).forEach(function (b) { b.addEventListener('click', function () { go(i - 1); }); });
      $$('[data-pg4-next]', c).forEach(function (b) { b.addEventListener('click', function () { go(i + 1); }); });
      dots.concat(thumbs).forEach(function (d) { d.addEventListener('click', function () { var k = dots.indexOf(d); if (k < 0) k = thumbs.indexOf(d); go(k); }); });
      var stage = $('.pg4-carousel-stage, .pg4-top-carousel-stage', c) || c;
      stage.addEventListener('touchstart', function (e) { if (e.touches.length === 1) { x0 = e.touches[0].clientX; dx = 0; } }, { passive: true });
      stage.addEventListener('touchmove', function (e) { if (x0 !== null) dx = e.touches[0].clientX - x0; }, { passive: true });
      stage.addEventListener('touchend', function () { if (x0 === null) return; if (Math.abs(dx) > 42) go(dx < 0 ? i + 1 : i - 1); x0 = null; }, { passive: true });
      c._pg4go = go; go(0);
    });
  }

  /* ---- horizontal scroll rows with arrows ---- */
  function initScrollers(root) {
    $$('[data-pg4-scroller]', root).forEach(function (s) {
      if (!once(s, 'Sc')) return;
      var row = $('[data-pg4-row]', s); if (!row) return;
      var amt = function () { return Math.max(230, row.clientWidth * 0.78); };
      $$('[data-pg4-prev]', s).forEach(function (b) { b.addEventListener('click', function () { row.scrollBy({ left: -amt(), behavior: 'smooth' }); }); });
      $$('[data-pg4-next]', s).forEach(function (b) { b.addEventListener('click', function () { row.scrollBy({ left: amt(), behavior: 'smooth' }); }); });
    });
    /* comp v4.24: automatic mobile swipe arrows on card rows */
    $$('.pg4-review-grid, .pg4-product-cards, .pg4-stat-grid, .pg4-comfort-grid', root).forEach(function (row) {
      if (row.closest('.pg4-mobile-swipe-shell') || row.closest('.pg4-benefits-swipe') || !once(row, 'Ms')) return;
      var shell = document.createElement('div'); shell.className = 'pg4-mobile-swipe-shell';
      row.parentNode.insertBefore(shell, row); shell.appendChild(row);
      ['prev', 'next'].forEach(function (dir) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'pg4-mobile-swipe-arrow pg4-' + dir;
        b.setAttribute('aria-label', dir === 'prev' ? 'Previous items' : 'More items'); b.textContent = dir === 'prev' ? '‹' : '›';
        b.addEventListener('click', function () { row.scrollBy({ left: (dir === 'prev' ? -1 : 1) * Math.max(230, row.clientWidth * 0.78), behavior: 'smooth' }); });
        shell.appendChild(b);
      });
    });
  }

  function init(root) { root = root || document; initHeader(root); initCarousels(root); initScrollers(root); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var c = e.target.closest && e.target.closest('[data-pg4-carousel]');
    if (c && c._pg4go) { var sl = Array.prototype.slice.call(c.querySelectorAll('.pg4-carousel-slide, .pg4-top-carousel-slide')); var k = sl.indexOf(e.target); if (k >= 0) c._pg4go(k); }
    if (e.target.scrollIntoView && e.target.closest('[data-pg4-row], .pg4-review-grid, .pg4-product-cards')) e.target.scrollIntoView({ block: 'nearest', inline: 'center' });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }); else init(document);
})();
/* ---- buy box: variant select + package selector update price and Add to Cart ---- */
(function () {
  'use strict';
  function setPrice(box, d) {
    if (!box) return;
    var now = box.querySelector('[data-pg4-price]'), cmp = box.querySelector('[data-pg4-compare]'), save = box.querySelector('[data-pg4-save]'), btn = box.querySelector('[data-pg4-add]');
    if (now && d.price) now.textContent = d.price;
    if (cmp) { cmp.textContent = d.compare || ''; cmp.hidden = !d.compare; }
    if (save) { save.textContent = d.save ? (save.getAttribute('data-template') || 'SAVE [percent]%').replace('[percent]', d.save) : ''; save.hidden = !d.save; }
    if (btn) { var ok = d.available !== 'false'; btn.disabled = !ok; btn.textContent = ok ? btn.getAttribute('data-label') : (btn.getAttribute('data-soldout') || 'Sold out'); }
  }
  function setSticky(id, d) {
    var bar = document.querySelector('[data-pg4-sticky]');
    if (!bar || !id) return;
    var input = bar.querySelector('input[name="id"]'), price = bar.querySelector('.pg4-sticky-price'), btn = bar.querySelector('button[type="submit"]');
    if (input) input.value = id;
    if (price && d.price) { price.innerHTML = ''; var b = document.createElement('b'); b.textContent = d.price; price.appendChild(b); if (d.compare) { var c = document.createElement('s'); c.textContent = d.compare; price.appendChild(document.createTextNode(' ')); price.appendChild(c); } }
    if (btn) btn.disabled = d.available === 'false';
  }
  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('select[data-pg4-variant-input]');
    if (!sel) return;
    var o = sel.options[sel.selectedIndex];
    setPrice(sel.closest('[data-pg4-buy]'), o.dataset);
    if (sel.closest('.pg4-pdp-hero')) setSticky(o.value, o.dataset);
  });
  document.addEventListener('click', function (e) {
    var card = e.target.closest && e.target.closest('[data-pg4-package]');
    if (!card) return;
    var wrap = card.closest('[data-pg4-packages]');
    wrap.querySelectorAll('[data-pg4-package]').forEach(function (c) {
      var on = c === card; c.classList.toggle('pg4-selected', on);
      c.querySelectorAll('.pg4-package-selected-badge').forEach(function (b) { b.remove(); });
      if (on) { var b = document.createElement('div'); b.className = 'pg4-package-selected-badge'; b.textContent = wrap.getAttribute('data-selected-label') || '✓ Selected'; c.insertBefore(b, c.firstChild); }
    });
    if (!card.dataset.variantId) return;
    var sec = card.closest('section');
    var pb = sec && sec.querySelector('[data-pg4-package-buy]');
    if (pb) {
      var pi = pb.querySelector('[data-pg4-package-input]'), pbtn = pb.querySelector('[data-pg4-package-add]');
      if (pi) pi.value = card.dataset.variantId;
      if (pbtn) { var ok = card.dataset.available !== 'false'; pbtn.disabled = !ok; pbtn.textContent = ok ? (pbtn.getAttribute('data-template') || 'Add to cart').replace('[package]', card.dataset.name || '').replace('[price]', card.dataset.price || '') : (wrap.getAttribute('data-soldout') || 'Sold out'); }
    }
    var box = document.querySelector('[data-pg4-buy]');
    if (!box) return;
    var input = box.querySelector('[data-pg4-variant-input]');
    if (input) {
      if (input.tagName === 'SELECT') {
        var exists = Array.prototype.some.call(input.options, function (o) { return o.value === card.dataset.variantId; });
        if (!exists) { var o = document.createElement('option'); o.value = card.dataset.variantId; o.textContent = card.dataset.name; input.appendChild(o); }
      }
      input.value = card.dataset.variantId;
    }
    setPrice(box, card.dataset);
    setSticky(card.dataset.variantId, card.dataset);
  });
})();

/* TV offer carousels: play looping slides whenever they are visible (swiped or scrolled into view), pause when hidden */
(function () {
  function wire(root) {
    var vids = (root || document).querySelectorAll('.pg4-loop-media video');
    if (!vids.length) return;
    if (!('IntersectionObserver' in window)) { vids.forEach(function (v) { v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting && e.intersectionRatio > 0.4) { v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else { v.pause(); }
      });
    }, { threshold: [0, 0.4, 0.75] });
    vids.forEach(function (v) { if (!v.dataset.pg4Loop) { v.dataset.pg4Loop = '1'; io.observe(v); } });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { wire(); }); else wire();
  document.addEventListener('shopify:section:load', function (e) { wire(e.target); });
})();
